export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/dfxWorker.90b7dd88.worker.js");
}
